export default __webpack_public_path__ + "static/media/dark-survey.f86ddc18.png";